module.exports = __webpack_public_path__ + "media/react/gre/pages/essay_review/illustrated-avatars/3-54ddb2ee2de0cd591a22186da96a4bbb.png";